// extracted by mini-css-extract-plugin
module.exports = {"checkbox_container":"Checkbox_checkbox_container__2BX81","checkbox":"Checkbox_checkbox__3RCxd"};